import { Link, useLocation } from 'react-router';
import { useT } from '@/i18n';
import { DRAWER } from '@/app/nav';
import { useBodyClass } from '@/app/providers/bodyClass';
import { useShell } from '@/app/providers/Shell';
import { useTheme } from '@/app/providers/Theme';
import { Segmented } from '@/components/ui/Controls';
import { Icon } from '@/components/ui/Icon';
import { useOpenSupport } from '@/features/profile/Support';
import { cx } from '@/lib/format';
import { NavLock } from '@/features/plans/Upgrade';
import { closeTopLayer, useLayer } from '@/lib/overlay';

export function Drawer() {
  const { pathname } = useLocation();
  const { navOpen, setNavOpen } = useShell();
  const { theme, setTheme } = useTheme();
  const openSupport = useOpenSupport();
  useBodyClass('nav-open', navOpen);
  const { t } = useT();
  useLayer('drawer', navOpen, () => setNavOpen(false));
  return (
    <>
      <aside className="drawer" aria-label={t('a11y.menu')}>
        <div className="drawer-top">
          <Link className="drawer-brand" to="/"><img className="logo-d" src="/assets/brand/orca-logo.png" alt="Orca" /><img className="logo-l" src="/assets/mascot/orca-logo-payment.png" alt="Orca" /></Link>
          <button className="dr-x" type="button" aria-label={t('a11y.closeMenu')} onClick={() => setNavOpen(false)}><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg></button>
        </div>
        <nav>
          {DRAWER.map(([g, pages]) => (
            <div className="dr-g" key={g}>
              <span>{t(`nav:drawer.${g}`)}</span>
              {pages.map((p) => <Link key={p.path} className={cx('dr-i', p.path === pathname && 'on')} to={p.path}><Icon name={p.icon} /><span>{p.title}</span><NavLock path={p.path} label /></Link>)}
              {g === 'account' && <>
                <button type="button" className="dr-i" onClick={() => { setNavOpen(false); openSupport(); }}><Icon name="mail" /><span>{t('nav:support')}</span></button>
                <Link className="dr-i" to="/profile#referral"><Icon name="link" /><span>{t('nav:referral')}</span></Link>
              </>}
            </div>
          ))}
        </nav>
        <div className="dr-foot">
          <Segmented className="dr-seg" label={t('a11y.theme')} value={theme} onChange={setTheme} options={[
            { value: 'dark', label: <><Icon name="moon" />{t('a11y.dark')}</> },
            { value: 'light', label: <><Icon name="sun" />{t('a11y.light')}</> },
          ]} />
        </div>
      </aside>
      <div className="drawer-scrim" onClick={closeTopLayer} />
    </>
  );
}
